import { Particle } from "../particle";
import { colorConstant, hold, lerp, parabolic, randomBetween } from "../interpolation";

// Darker than the corresponding burst particles (BloodParticle uses r:180, g:20, b:20)
const DARK_RED = { r: 150, g: 20, b: 20 };

/**
 * Small blood drops that drip/fall with gravity. Used as a continuous
 * damage indicator for organic mobs. Visually distinct from BloodParticle,
 * which is an explosive directional burst — this is a slow, downward drip.
 */
export class BloodDripParticle extends Particle {
	/** Emission interval for generators (ms between particles). */
	static readonly emitIntervalMs = 200;

	constructor(originX: number, originY: number, baseColor: { r: number; g: number; b: number } = DARK_RED) {
		const ttl = randomBetween(300, 600);

		// Slight horizontal drift so drops don't stack vertically
		const vx = randomBetween(-0.3, 0.3);

		// Low initial downward speed — gravity does most of the work
		const vy = randomBetween(0.2, 0.6);

		const gravity = randomBetween(4, 6);

		const size = randomBetween(0.25, 0.4);

		const r = baseColor.r + randomBetween(-10, 10);
		const g = baseColor.g + randomBetween(-5, 5);
		const b = baseColor.b + randomBetween(-5, 5);

		// Randomize spawn position around the cell so drops don't all come from center
		const ox = originX + randomBetween(-0.45, 0.45);
		const oy = originY + randomBetween(-0.45, 0.45);

		super(ox, oy, {
			ttl,
			size: lerp(size, size * 0.6),
			opacity: hold(1.0, 0.7, lerp(1.0, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, 0),
			position: parabolic(vx, vy, gravity),
		});
	}
}
